import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useCallback } from 'react';
import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useTasksJobs } from '../hooks/useTasksJobs';
export function useMarkTasksSeen() {
    const { api } = useStoreActions();
    const { optimisticUpdate } = useTasksJobs();
    const { mutate } = useMutationState({
        mutationFn: (jobIds)=>api.jobs.markJobsSeen(jobIds.map((jobId)=>({
                    jobId,
                    seen: true
                }))),
        onMutate: (jobIds)=>{
            const seenSet = new Set(jobIds);
            optimisticUpdate((tasks)=>tasks.map((t)=>seenSet.has(t.jobId) ? _object_spread_props(_object_spread({}, t), {
                        seen: true
                    }) : t));
        },
        onError: (_err, jobIds)=>{
            const seenSet = new Set(jobIds);
            optimisticUpdate((tasks)=>tasks.map((t)=>seenSet.has(t.jobId) ? _object_spread_props(_object_spread({}, t), {
                        seen: false
                    }) : t));
        }
    });
    const markSeen = useCallback((jobIds)=>mutate(jobIds), [
        mutate
    ]);
    return {
        markSeen
    };
}
